export const LIST_MODULECODE_MAP = {
  '/achievements': 'TDS_search_data_research',
  '/dynamic': 'TDS_search_data_trend',
  '/expert': 'TDS_search_person',
  '/organization': 'TDS_search_org',
  '/search': 'TDS_search_all',
}
export const DETAIL_DATASETCODE_MAP = {
  think_tank_data_research: { path: '/achievements/detail', moduleCode: 'TDS_search_data_research' },
  think_tank_data_trend: { path: '/dynamic/detail', moduleCode: 'TDS_search_data_trend' },
  think_tank_person: { path: '/expert/detail', moduleCode: 'TDS_search_person' },
  think_tank_organization: { path: '/organization/detail', moduleCode: 'TDS_search_org' },
}

export const TYPE_MAP = {
  research: { color: '#0097FE', name: '研究', type: 'Research' },
  article: { color: '#FFAE00', name: '文章', type: 'Article' },
  blog: { color: '#00C150', name: '博客', type: 'Blog' },
  opinion: { color: '#7C2BB8', name: '意见', type: 'Opinion' },
  paper: { color: '#7C2BB8', name: '论文', type: 'Paper' },
  report: { color: '#7C2BB8', name: '报告', type: 'Report' },
  publication: { color: '#7C2BB8', name: '出版物', type: 'Publication' },
  activities: { color: '#7C2BB8', name: '活动', type: 'Activities' },
  analysis: { color: '#7C2BB8', name: '分析', type: 'Analysis' },
  journal: { color: '#7C2BB8', name: '期刊', type: 'Journal' },
  media: { color: '#7C2BB8', name: '多媒体', type: 'Media' },
  press: { color: '#7C2BB8', name: '报刊', type: 'Press' },
  project: { color: '#7C2BB8', name: '项目', type: 'Project' },
  policybrief: { color: '#7C2BB8', name: '政策', type: 'Policybrief' },
  book: { color: '#7C2BB8', name: '书籍', type: 'Book' },
  speak: { color: '#7C2BB8', name: '演讲', type: 'Speak' },
  perspective: { color: '#7C2BB8', name: '观点', type: 'Perspective' },
  conversation: { color: '#7C2BB8', name: '会谈', type: 'Conversation' },
  magazine: { color: '#7C2BB8', name: '杂志', type: 'Magazine' },
  conferences: { color: '#7C2BB8', name: '会议', type: 'Conferences' },
  newsletters: { color: '#7C2BB8', name: 'newsletters', type: 'Newsletters' },
  event: { color: '#7C2BB8', name: '事件', type: 'Event' },
  video: { color: '#7C2BB8', name: '视频', type: 'Video' },
  seminars: { color: '#7C2BB8', name: 'Seminars', type: 'Seminars' },
  person: { color: '#7C2BB8', name: 'Person', type: 'Person' },
  other: { color: '#7C2BB8', name: '其他', type: 'Other' },
}

export const LIST_CODE_MAP = {
  '/achievements': {
    moduleCode: 'TDS_search_data_research',
    datasetCodes: 'think_tank_data_research',
  },
  '/dynamic': {
    moduleCode: 'TDS_search_data_trend',
    datasetCodes: 'think_tank_data_trend',
  },
  '/expert': {
    moduleCode: 'TDS_search_person',
    datasetCodes: 'think_tank_person',
  },
  '/organization': {
    moduleCode: 'TDS_search_org',
    datasetCodes: 'think_tank_organization',
  },
  '/search': {
    moduleCode: 'TDS_search_all',
    datasetCodes: 'think_tank_data_research',
  },
}
